import styled, { css } from 'styled-components'

export const NavQuizzesDueBadge = styled.span<{ $inline?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 17px;
  padding: 0 6px;
  border-radius: 9px;
  background: #ea4335;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
  min-width: 25px;

  ${({ $inline }) =>
    $inline
      ? css`
          position: static;
          margin-left: 6px;
        `
      : css`
          position: absolute;
          top: -1px;
          right: 6px;
        `}
`
